(function () {
  'use strict';

  if (typeof Lenis === 'undefined' || typeof gsap === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var lenis = new Lenis({
    lerp: 0.1,        // smoothness — lower feels silkier, higher is snappier
    smoothWheel: true
  });

  // Sync Lenis scroll position with GSAP ScrollTrigger every frame.
  // Without this, ScrollTrigger reads the native scroll position which
  // won't match what Lenis is rendering, causing stutters in scroll-driven sections.
  if (typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function (time) {
      lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);
  } else {
    // Fallback: run Lenis on its own rAF loop if ScrollTrigger isn't available.
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
  }

  // When lazy-loaded or scroll-revealed sections expand the page height,
  // Lenis still holds the old scroll length. ResizeObserver detects the
  // body growing and forces Lenis to recalculate its scroll dimensions.
  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(function () {
      lenis.resize();
    }).observe(document.body);
  }
})();
